import { assertNever } from "../../../../../utils/assertNever.js";
const cycleOrderDirection = (direction) => {
  if (direction === null) {
    return "asc";
  }
  if (direction === "asc") {
    return "desc";
  }
  if (direction === "desc") {
    return null;
  }
  return assertNever();
};
export {
  cycleOrderDirection
};
//# sourceMappingURL=DataGridOrderDirection.js.map
